const themes = {
  default: {
    title: "NoLimit Care",
    trial: true,
    favicon: require("img/nolimit/favicon.png"),
    loginImageTop: require("img/nolimit/logo-shadow.png"),
    loginImageMiddle: require("img/nolimit/laptop-login.png"),
    loginImageBottom: require("img/nolimit/logo-nolimit.png"),
    loginBrandText: "Welcome to NoLimit Care",
    loginBackground: "#edf7f9",
    loginInputBottomBorder: "#b4ddf9",
    loginInputBottomBorderHover: "#6bbcf4",
    loginSignButton: "#cee9f4",
    "sidemenu-logo": require("svg/logo.svg"),
    greenIndicator: "green",
    uiText: "#6C7379",
    infoText: "#404040",
    loginText: "#63b7f5",
    unselectedTab: "#D0DAE3",
    panelBorder: "#d2d3d5",
    panelBackground: "white",
    panelLoginBackground: "linear-gradient(200deg, #02b8a1, #538ccf)",
    moduleBackground: "#E8E9EA",
    sidemenuBackground: "#1F445A",
    textAreaBackground: "#E2E2E2",
    sidemenuHover: "#05223E",
    sidemenuBorder: "#177FBF",
    blueButton: "#338DCA",
    grayButton: "#6C7379",
    greenButton: "#4ade88",
    whiteButton: "#ffffff",
    transparent: "transparent",
    tooltip: "#20445a",
    headerTitle: "#5296EE",
    headerButtonBorder: "#A5A5A5",
    headerButtonText: "#777",
    normalCaseIndicator: "#6CD65C",
    warningCaseIndicator: "#FAD91A",
    alertCaseIndicator: "#EE3A3B",
    alertCaseBackground: "#F6DCDB",
    supervisorPanelHeader: "#20445A",
    blueHighlight: "#E9ECF1",
    blueBorder: "#3488C6",
    normalPendingStream: "#FBC726",
    rejectedPendingStream: "#ee3a3b",
    editingPendingStream: "#C3C4C6",
    mask: "rgba(0, 0, 0, 0.5)",
    shadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 15px rgba(0, 0, 0, 0.23)",
    onlineStatus: "#4FE47D",
    idleStatus: "#FEDF22",
    offlineStatus: "white",
    alertError: "#f0584b",
    alertWarning: "#e8bd0c",
    alertSuccess: "#21ba9c",
    alertInfo: "#4d9cd4",
    facebookButton: "#3b5998",
    twitterButton: "#55acee",
    instagramButton: "#a535b2",
    lineButton: "#00c201",
    liveChatButton: "#33b0a9"
  },
  // for custom theme, you may specify only changed color
  binokular: {
    title: "Binokular",
    trial: false,
    favicon: require("img/binokular/favicon.png"),
    loginImageTop: require("img/binokular/bino_text.png"),
    loginImageMiddle: require("img/binokular/laptop-care-whitelabel.png"),
    loginImageBottom: "-",
    loginBrandText: "Welcome to Binokular",
    loginBackground: "white",
    loginInputBottomBorder: "#ffffff",
    loginInputBottomBorderHover: "white",
    loginSignButton: "white",
    "sidemenu-logo": require("img/binokular/logo.png"),
    textAreaBackground: "#E2E2E2",
    sidemenuBackground: "#dfcf92",
    sidemenuHover: "#c8ad46",
    sidemenuBorder: "#B3222A",
    panelLoginBackground: "#c8ad46",
    moduleBackground: "#D1D4DD",
    headerTitle: "#c8ad46",
    blueButton: "#c8ad46"
  },
  asyst: {
    title: "Asyst",
    trial: false,
    favicon: require("img/asyst/favicon.png"),
    loginImageTop: require("img/asyst/asyst-besar.png"),
    loginImageMiddle: require("img/asyst/laptop-care-whitelabel.png"),
    loginImageBottom: "-",
    loginBrandText: "Welcome to Asyst",
    loginBackground: "white",
    loginInputBottomBorder: "#ffffff",
    loginInputBottomBorderHover: "white",
    loginSignButton: "white",
    "sidemenu-logo": require("img/asyst/logo.png"),
    textAreaBackground: "#E2E2E2",
    sidemenuBackground: "#1F445A",
    sidemenuHover: "#05223E",
    sidemenuBorder: "#3368b2",
    panelLoginBackground: "#66ac3c",
    moduleBackground: "#D1D4DD",
    headerTitle: "#66ac3c",
    blueButton: "#66ac3c"
  }
};

// helper function to change favicon
function changeFavicon(img) {
  let favicon = document.querySelector('link[rel="shortcut icon"]');

  if (!favicon) {
    favicon = document.createElement("link");
    favicon.setAttribute("rel", "shortcut icon");
    let head = document.querySelector("head");
    head.appendChild(favicon);
  }

  favicon.setAttribute("type", "image/png");
  favicon.setAttribute("href", img);
}

let prevThemeName = "";
export let CurrentTheme;
export function ChangeTheme(themeName) {
  const name = themeName ? themeName.toLowerCase() : "default";
  if (prevThemeName !== name) {
    const selected = themes[name];
    if (selected) {
      prevThemeName = name;
      CurrentTheme = Object.assign({}, themes.default, selected);
      // change page title
      if (CurrentTheme.title) document.title = CurrentTheme.title;
      // change favicon
      if (CurrentTheme.favicon) changeFavicon(CurrentTheme.favicon);
    }
  }
}

// on first load, change theme according to domain
const domain = window.location.hostname;
if (domain.search("binokular.net") !== -1) {
  ChangeTheme("binokular");
} else if (domain.search("asyst.care.nolimit.id") !== -1) {
  ChangeTheme("asyst");
} else {
  ChangeTheme("default");
}



// WEBPACK FOOTER //
// ./src/theme.js